import React from 'react';
import { Alert } from '../../../../../../base/components/Alert';
import { Button } from '../../../../../../base/components/Button';
import { PasswordInput } from '../../../../../../base/components/Forms/PasswordInput';
import { PhoneInput } from '../../../../../../base/components/Forms/PhoneInput';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';

import '../styles.scss';

export const LoginData = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { phone, password },
        errors,
    } = useAppSelector((state) => state.workerAppSettings.createLogin);
    const phoneInputConfig = useAppSelector((state) => state.workerApp.config.phoneInputConfig);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(settingsActions.setCreateLoginField({ id, value }));
    };

    const submitHandler = () => dispatch(settingsActions.createLoginSubmit());

    return (
        <div className='create-login'>
            <Alert
                text={__t(
                    'Укажите ваш номер телефона и создайте пароль, поскольку вы зарегистрировались через социальную сеть.',
                )}
                type='warn'
                icon='circle-exclamation-regular'
                className='create-login__alert'
            />
            <div className='create-login__form-item scroll-margin-for-fixed-header'>
                <p className='create-login__form-label'>{__t('Номер телефона')}</p>
                <PhoneInput
                    value={phone}
                    onChange={(value: string) => inputChangeHandler('phone', value)}
                    errors={errors?.phone}
                    onlyCountries={phoneInputConfig.countries}
                    preferredCountries={phoneInputConfig.preferredCountries}
                    localization={phoneInputConfig.localization}
                    tabIndex={1}
                />
            </div>

            <div className='create-login__form-item scroll-margin-for-fixed-header'>
                <p className='create-login__form-label'>{__t('Придумайте пароль')}</p>
                <PasswordInput
                    value={password}
                    placeholder={__t('Минимум 6 символов')}
                    onChange={(value: string) => inputChangeHandler('password', value)}
                    errors={errors?.password}
                    tabIndex={2}
                />
            </div>
            <Button className='create-login__button' onClick={submitHandler}>
                {__t('Сохранить')}
            </Button>
        </div>
    );
};
